import { journeyApi } from "../services/journey-service";
import { onDemandApi } from "../services/ondemand-service";
import { quicksightApi } from "../services/quicksight-service";
import { responseApi } from "../services/response.service";
import { deliveryApi } from "../services/delivery-service";
import { schedulerApi } from "../services/scheduler.service";
import { simulationApi } from "../services/simulation-service";
import { tenancyApi } from "../services/tenancy.service";

import { universityApi } from "../services/university-service";
import { userApi } from "../services/user-service";
import { reportApi } from "../services/report.service";
import { emailIdentityServiceApi } from "../services/email-identity-service";
import { logsApi } from "../services/logs-service";

const api = {
    [journeyApi.reducerPath]: journeyApi.reducer,
    [onDemandApi.reducerPath]: onDemandApi.reducer,
    [quicksightApi.reducerPath]: quicksightApi.reducer,
    [responseApi.reducerPath]: responseApi.reducer,
    [deliveryApi.reducerPath]: deliveryApi.reducer,
    [schedulerApi.reducerPath]: schedulerApi.reducer,
    [simulationApi.reducerPath]: simulationApi.reducer,
    [tenancyApi.reducerPath]: tenancyApi.reducer,

    [universityApi.reducerPath]: universityApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [emailIdentityServiceApi.reducerPath]: emailIdentityServiceApi.reducer,
    [logsApi.reducerPath]: logsApi.reducer
};

export default api;